import { useMemo } from "react"

import type { DashboardUseCase } from "../../../types/use-case.types"

import { SiteCard } from "./site-card"
import { SITE_CHART_COLORS } from "../../../types/use-case.types"

type SiteCardsProps = {
  siteMap: Map<string, DashboardUseCase[]>
}

export function SiteCards({ siteMap }: SiteCardsProps) {
  const entries = useMemo(() => {
    return [...siteMap.entries()]
      .sort(([a], [b]) => a.localeCompare(b))
      .map(([site, ucs], i) => ({
        site,
        useCases: ucs,
        color: SITE_CHART_COLORS[i % SITE_CHART_COLORS.length],
      }))
  }, [siteMap])

  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
      {entries.map((entry) => (
        <SiteCard
          key={entry.site}
          color={entry.color}
          site={entry.site}
          useCases={entry.useCases}
        />
      ))}
    </div>
  )
}
